// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/donation.css
// module id = 2664
// module chunks = 2